import A11yDialog from 'a11y-dialog';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dialog-container').forEach(el => {
    const dialog = new A11yDialog(el, document.getElementById('main'));

    // Add any event handlers here...
    // See https://github.com/edenspiekermann/a11y-dialog#js-api
  });
  document.querySelectorAll('a[data-a11y-dialog-show]').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        return false;
    });
  });
});
